import React from 'react'
import { withI18n } from '@lingui/react'
import { func, number, string } from 'prop-types'

import { i18nType } from 'views/utils/propTypes'

import Form from 'views/components/atoms/Form'
import InputWithButton from 'views/components/molecules/InputWithButton'

import SearchBoxList from 'views/components/organisms/SearchBox/SearchBoxList'

import Experiment from 'views/components/utils/optimizely/Experiment'
import Variant from 'views/components/utils/optimizely/Variant'
import { AFTER_QUERY_SUGGEST_LAYER } from 'shared/experiments/consts'

import './../SearchBox.scss'
import './SearchBoxDesktop.scss'

const SearchBoxDesktop = ({
  i18n,
  query,
  inputId,
  displayResults,
  products,
  handleInputUpdate,
  handleClear,
  handleKeyUp,
  handleSubmit,
  highlightedIndex,
  displayedValue,
  formAction,
  handleShowAll,
  handleItemClick,
  hideResults,
  handleValueChange
}) => {
  const formProps = {
    action: formAction,
    name: 'search-box',
    method: 'get',
    'data-clientside-hook': 'chargeUrlSearchParams'
  }

  const inputProps = {
    type: 'search',
    buttonLabel: i18n._('general.button.label.search'),
    buttonIcon: 'search',
    name: 'query',
    inputId,
    disableAutoCompleteAndFriends: true,
    onChange: handleInputUpdate,
    onClear: handleClear,
    value: displayedValue,
    placeholder: i18n._('general.label.placeholder.search'),
    buttonType: 'submit',
    mediumViewIconOnly: true,
    grayInputBg: true
  }

  return (
    <div className="o-SearchBox">
      <Experiment name={AFTER_QUERY_SUGGEST_LAYER} preventActivation>
        <Variant name="default">
          {() => (
            <Form {...formProps} onSubmit={handleSubmit}>
              <InputWithButton {...inputProps} onKeyUp={handleKeyUp} />
            </Form>
          )}
        </Variant>
        <Variant name="variation_1">
          {() => (
            <Form {...formProps} onSubmit={e => e.preventDefault()}>
              <InputWithButton {...inputProps} />
            </Form>
          )}
        </Variant>
        <Variant name="variation_2">
          {() => (
            <Form {...formProps} onSubmit={e => e.preventDefault()}>
              <InputWithButton {...inputProps} />
            </Form>
          )}
        </Variant>
      </Experiment>
      <SearchBoxList
        query={query}
        displayResults={displayResults}
        products={products}
        highlightedIndex={highlightedIndex}
        formAction={formAction}
        handleShowAll={handleShowAll}
        handleItemClick={handleItemClick}
        hideResults={hideResults}
        handleValueChange={handleValueChange}
      />
    </div>
  )
}

/* eslint-disable react/no-typos */
SearchBoxDesktop.propTypes = {
  i18n: i18nType.isRequired,
  query: SearchBoxList.propTypes.query,
  inputId: string.isRequired,
  formAction: string.isRequired,
  displayResults: SearchBoxList.propTypes.displayResults,
  products: SearchBoxList.propTypes.products,
  handleItemClick: SearchBoxList.propTypes.handleItemClick,
  handleInputUpdate: func,
  handleClear: func,
  handleKeyUp: func,
  handleSubmit: func,
  handleShowAll: func,
  highlightedIndex: number,
  displayedValue: string,
  hideResults: func,
  handleValueChange: func
}

SearchBoxDesktop.defaultProps = {
  query: SearchBoxList.defaultProps.query,
  displayResults: SearchBoxList.defaultProps.displayResults,
  products: SearchBoxList.defaultProps.products,
  handleItemClick: SearchBoxList.defaultProps.handleItemClick,
  handleInputUpdate: null,
  handleClear: null,
  handleKeyUp: null,
  handleSubmit: null,
  handleShowAll: null,
  highlightedIndex: -1,
  displayedValue: '',
  hideResults: null,
  handleValueChange: null
}

export default withI18n()(SearchBoxDesktop)
